"use client"

import React, { useState } from 'react'
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

const Audioplayer = ({ url }) => {
  const [play, setPlay] = useState(false);

  return (
    <div>
      <AudioPlayer
        autoPlay
        src={`voice/${url}`}
        onPlay={e => console.log("onPlay")}
        showJumpControls={false}
        layout={"horizontal-reverse"}
        customAdditionalControls={[]}
        autoPlayAfterSrcChange={false}
      />
  
    </div>
  )
}

export default Audioplayer